import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getVkycUrl } from "../utils/urlHelper";

const vkycApi = createApi({
  reducerPath: "vkyc",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_AUTH_URL}`,
    prepareHeaders: async (headers) => {
      const token = await sessionStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("Accept", "application/json; version=3.0");
      headers.set("Source", "LPLWEB");
      return headers;
    },
  }),
  endpoints: (builder) => {
    return {
      preVkycDetails: builder.mutation({
        query: (body) => ({
          url: getVkycUrl("pre_vkyc_details"),
          method: "POST",
          body,
        }),
      }),
      processVkycResponse: builder.mutation({
        query: (body) => ({
          url: getVkycUrl("process_vkyc_response"),
          method: "POST",
          body,
        }),
      }),
    };
  },
});

export const { usePreVkycDetailsMutation, useProcessVkycResponseMutation } = vkycApi;

export { vkycApi };
